// eslint-disable-next-line
import { produce } from 'immer';
import { returnID, generateUniqueID, reorderArray } from 'src/components/form/utilities/Utilities';

const DEFAULT_QUESTION = [
  {
    id: 1,
    label: 'Nouvelle Question',
    labelRic: 'Montée en compétences',
    type: 'short_answer',
    star: 10,
    required: false,
    description: '',
    satisfaction: false,
    showDescription: false,
    linearScaleOptionType: 'thowOptions',
    mark: 0,
    date: new Date(),
    time: new Date(),
    style: true, // false => small, true => large
    file: 'image', // image pdf
    options: [{ id: 1, label: 'Nouvelle Réponse', answer: false }],
    optionsRic: [{ id: 1, label: 'Nouvelle Compétence', answer: false }], // ric Rise in competence
    oneAnswerPerLine: false,
    linearScaleOptions: [
      { id: 1, option: 1, label: '' },
      { id: 2, option: 5, label: '' },
    ],
    grid: {
      lines: [{ id: 1, label: 'ligne 1' }],
      colunms: [{ id: 1, label: 'colonne 1' }],
      checked: [{ lineID: 1, colunmID: 1, checked: false }],
    },
  },
];

const DEFAULT_SECTION = {
  id: 1,
  label: 'Section',
  selected: true,
  description: '',
  questions: DEFAULT_QUESTION,
  expanded: true,
};

const INITIAL_VALUES = [DEFAULT_SECTION];

export const RESET = 'RESET';
export const DRAG_END = 'DRAG_END';
export const ADD_SECTION = 'ADD_SECTION';
export const SET_SECTION = 'SET_SECTION';
export const ADD_QUESTION = 'ADD_QUESTION';
export const DELETE_SECTION = 'DELETE_SECTION';
export const SELECT_SECTION = 'SELECT_SECTION';
export const ADD_QUESTION_RIC = 'ADD_QUESTION_RIC';
export const DUPLICATE_SECTION = 'DUPLICATE_SECTION';
export const RESET_SECTION_VALUE = 'RESET_SECTION_VALUE';
export const CHANGE_SECTION_LABEL = 'CHANGE_SECTION_LABEL';
export const CHANGE_SECTION_EXPANDED = 'CHANGE_SECTION_EXPANDED';
export const CHANGE_SECTION_DESCRIPTION = 'CHANGE_SECTION_DESCRIPTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const DUPLICATE_QUESTION = 'DUPLICATE_QUESTION';
export const CHANGE_QUESTION_PROPERTY = 'CHANGE_QUESTION_PROPERTY';
export const CHANGE_QUESTION_GRID = 'CHANGE_QUESTION_GRID';

const sectionsReducer = (state = INITIAL_VALUES, action) => 
// eslint-disable-next-line
  produce(state, draft => {

    const handelQuestionChange = (sectionID, questionID, property, value) => {
      const section = draft.find((sec) => sec.id === sectionID);
      if (section) {
        const question = section.questions.find((ques) => ques.id === questionID);
        if (question) {
          if (property === 'mark') question.mark = value;
          else if (property === 'file') question.file = value;
          else if (property === 'star') question.star = value;
          else if (property === 'grid') question.grid = value;
          else if (property === 'label') question.label = value;
          else if (property === 'starRic') question.star = value;
          else if (property === 'options') question.options = value;
          else if (property === 'required') question.required = value;
          else if (property === 'labelRic') question.labelRic = value;
          else if (property === 'style') question.style = !question.style;
          else if (property === 'optionsRic') question.optionsRic = value;
          else if (property === 'description') question.description = value;
          else if (property === 'showDesc') question.showDescription = value;
          else if (property === 'satisfaction') question.satisfaction = value;
          else if (property === 'oneAnswerPerLine') question.oneAnswerPerLine = value;
          else if (property.slice(0, -1) === 'linearScaleOptions') {
            const option = question.linearScaleOptions.find((op) => op.id === parseInt(property.substr(property.length - 1), 10));
            if (option) option.option = value;
          }
          else if (property.slice(0, -1) === 'linearScaleLabel') {
            const option1 = question.linearScaleOptions.find((op1) => op1.id === parseInt(property.substr(property.length - 1), 10));
            if (option1) option1.label = value;
          }
          else if (property === 'type') {
            const types = ["multiple_choice", "checkboxes", "dropdown"];
            if (types.includes(value)) {
              const newOptions_ = question.options.map((item) => ({ ...item, answer: false }));
              question.type = value;
              question.options = newOptions_;
              question.iric = false;
            } else {
              question.type = value;
            }
          }
        }
      }
    };

    switch (action.type) {
      case RESET: {
        return INITIAL_VALUES;
      }
      case ADD_SECTION: {
        const id = generateUniqueID(draft);
        // eslint-disable-next-line
        draft.forEach(section => section.selected = false);
        draft.push({ ...DEFAULT_SECTION, id });
        break;
      }
      case SET_SECTION: {
        return action.payload;
      }
      case ADD_QUESTION: {
        const selectedSection = draft.find((section) => section.selected === true);
        if (selectedSection) {
          let questionID = generateUniqueID(selectedSection.questions);
          questionID = parseInt(selectedSection.id.toString() + questionID.toString(), 10);
          selectedSection.questions.push({ ...DEFAULT_QUESTION[0], id: questionID });
          selectedSection.expanded = true;
        }
        break;
      }
      case DRAG_END: {
        const { source, destination, type, draggableId } = action.payload;
        const fromIndex = source.index;
        const toIndex = destination?.index;

        if (!destination) {
          return draft;
        }
        if (source.droppableId === destination.droppableId && fromIndex === toIndex) {
          return draft;
        }

        if (type === 'form') {
          if (source.droppableId === destination.droppableId) {
            reorderArray(draft, fromIndex, toIndex);
          }
        }

        if (type === 'section') {
          if (source.droppableId === destination.droppableId) {
            const sectionID = returnID(draggableId);
            const section = draft.find((sec) => sec.id === sectionID);
            if (section) {
              reorderArray(section.questions, fromIndex, toIndex);
            }
          } else {
            const toSectionID = returnID(destination.droppableId);
            const fromSectionID = returnID(source.droppableId);
            const toSection = draft.find((sec) => sec.id === toSectionID);
            const fromSection = draft.find((sec) => sec.id === fromSectionID);
            if (toSection && fromSection) {
              const toQuestion = toSection.questions;
              const fromQuestion = fromSection.questions;
              const newID = generateUniqueID(toQuestion);
              const removeQuestion = fromQuestion.splice(fromIndex, 1)[0];
              removeQuestion.id = newID;
              toQuestion.splice(toIndex, 0, removeQuestion);
            }
          }
        }
        break;
      }
      case SELECT_SECTION: {
        const sectionid = action.payload;
        // eslint-disable-next-line
        draft.forEach(section => section.selected = section.id === sectionid);
        break;
      }
      case CHANGE_SECTION_EXPANDED: {
        const { sectionid, expanded } = action.payload;
        const section = draft.find((sec) => sec.id === sectionid);
        if (section) {
          section.expanded = expanded;
        }
        break;
      }
      case ADD_QUESTION_RIC: {
        const { question, idDelete } = action.payload;
        const selectedSection = draft.find((section) => section.selected === true);
        if (selectedSection) {
          selectedSection.questions = selectedSection.questions.filter((item) => item.id !== idDelete);
          const newRic = selectedSection.questions.filter((item) => item.id !== question.id);

          if (selectedSection.questions.length === 0) {
            selectedSection.questions = [question];
          } else if (newRic.length !== 0) {
            selectedSection.questions.push(question);
          }
        }
        break;
      }
      case DUPLICATE_SECTION: {
        const id = action.payload;
        if (!Number.isNaN(id)) {
          const newID = generateUniqueID(draft);
          const sectionIndex = draft.findIndex((section) => section.id === id);

          if (sectionIndex !== -1) {
            const duplicatedSection = { ...draft[sectionIndex], id: newID };
            draft.splice(sectionIndex + 1, 0, duplicatedSection);
            // eslint-disable-next-line
            draft.forEach((section, index) => section.selected = index === sectionIndex + 1);
          }
        }
        break;
      }
      case DELETE_SECTION: {
        const id = action.payload;
        if (!Number.isNaN(id)) {
          const sectionIndex = draft.findIndex((section) => section.id === id);
          if (sectionIndex !== -1) {
            draft.splice(sectionIndex, 1);
            if (sectionIndex > 0) {
              draft[sectionIndex - 1].selected = true;
            }
          }
        }
        break;
      }
      case DUPLICATE_QUESTION: {
        const { sectionID, questionID } = action.payload;
        const section = draft.find((sec) => sec.id === sectionID);
        if (section) {
          const questionIndex = section.questions.findIndex((ques) => ques.id === questionID);
          if (questionIndex > -1) {
            const newID = generateUniqueID(section.questions);
            const duplicatedQuestion = { ...section.questions[questionIndex], id: newID };
            section.questions.splice(questionIndex + 1, 0, duplicatedQuestion);
          }
        }
        break;
      }
      case DELETE_QUESTION: {
        const { sectionID, questionID } = action.payload;
        const section = draft.find((sec) => sec.id === sectionID);
        if (section) {
          section.questions = section.questions.filter((question) => question.id !== questionID);
        }
        break;
      }
      case CHANGE_QUESTION_PROPERTY: {
        const { sectionID, questionID, property, value } = action.payload;
        handelQuestionChange(sectionID, questionID, property, value);
        break;
      }
      case CHANGE_SECTION_LABEL: {
        const { sectionid, label } = action.payload;
        const section = draft.find((sec) => sec.id === sectionid);
        if (section) {
          section.label = label;
        }
        break;
      }
      case CHANGE_SECTION_DESCRIPTION: {
        const { sectionid, description } = action.payload;
        const section = draft.find((sec) => sec.id === sectionid);
        if (section) {
          section.description = description;
        }
        break;
      }
      case RESET_SECTION_VALUE: {
        const { sectionid, label, description } = action.payload;
        const section = draft.find((sec) => sec.id === sectionid);
        if (section) {
          section.label = label;
          section.description = description;
        }
        break;
      }
      default:
        return draft;
    }
  });

export default sectionsReducer;
